import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Star, X } from "lucide-react";

export default function Favorites() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/favorites").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const remove = async (f) => {
    await api.delete(`/favorites/${f.item_type}/${f.item_id}`);
    toast.success("Removed");
    load();
  };

  const grouped = items.reduce((a, f) => { (a[f.item_type] ||= []).push(f); return a; }, {});

  return (
    <div className="space-y-6" data-testid="favorites-page">
      <div>
        <div className="text-xs tracking-widest uppercase text-slate-500 font-semibold">Saved</div>
        <h1 className="font-heading text-3xl font-bold text-[#111827] mt-1 flex items-center gap-2">
          <Star className="w-7 h-7 text-amber-500" /> Favorites
        </h1>
      </div>

      {items.length === 0 ? (
        <Card className="border-slate-200"><CardContent className="p-10 text-center text-slate-500 text-sm">
          No favorites yet. Star a protocol or drug to save it here.
        </CardContent></Card>
      ) : (
        Object.entries(grouped).map(([type, list]) => (
          <div key={type}>
            <h2 className="font-heading font-bold capitalize text-[#111827] mb-3">{type}s</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
              {list.map((f) => (
                <Card key={f.id} className="border-slate-200">
                  <CardContent className="p-4 flex items-center justify-between gap-3">
                    <Link to={f.item_type === "calculator" ? `/app/calculators/${f.item_id}` : `/app/${f.item_type}s/${f.item_id}`} className="font-medium text-[#111827] hover:text-[#111827] truncate" data-testid={`fav-${f.item_id}`}>
                      {f.title}
                    </Link>
                    <Button size="sm" variant="ghost" onClick={() => remove(f)} data-testid={`fav-remove-${f.item_id}`}>
                      <X className="w-4 h-4" />
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
